import { defineComponent as _defineComponent } from 'vue';
import { BCard } from "bootstrap-vue";
import { computed, ref } from "vue";
import { getStoredProgressData } from "@/composables/persistentProgressMonitor";
import PersistentTaskProgressMonitorAlert from "@/components/Common/PersistentTaskProgressMonitorAlert.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ExistingInvocationExportProgressCard',
    props: {
        invocationId: null,
        useStsMonitor: null,
        useRemoteMonitor: null,
        exportToRemoteTaskId: null,
        exportToRemoteTargetUri: null,
        exportToStsRequestId: null
    },
    emits: ["onDismissSts", "onDismissRemote"],
    setup(__props, { expose, emit }) {
        const props = __props;
        const monitoringSource = "wizard";
        const hasExistingStsExportData = ref(false);
        const hasExistingRemoteExportData = ref(false);
        const exportToStsRequest = computed(() => ({
            source: monitoringSource,
            action: "export",
            taskType: "short_term_storage",
            object: {
                id: props.invocationId,
                type: "invocation",
            },
            description: `Exporting invocation ${props.invocationId} to Short Term Storage in preparation for download`,
        }));
        const exportToRemoteRequest = computed(() => ({
            source: monitoringSource,
            action: "export",
            taskType: "task",
            object: {
                id: props.invocationId,
                type: "invocation",
            },
            description: `Exporting invocation ${props.invocationId} to remote source`,
            remoteUri: props.exportToRemoteTargetUri,
        }));
        function updateExistingExportProgress() {
            const existingStsExportData = getStoredProgressData(exportToStsRequest.value);
            hasExistingStsExportData.value = existingStsExportData !== null;
            const existingRemoteExportData = getStoredProgressData(exportToRemoteRequest.value);
            hasExistingRemoteExportData.value = existingRemoteExportData !== null;
        }
        function dismissStsExport() {
            emit("onDismissSts");
            hasExistingStsExportData.value = false;
        }
        function dismissRemoteExport() {
            emit("onDismissRemote");
            hasExistingRemoteExportData.value = false;
        }
        updateExistingExportProgress();
        expose({
            updateExistingExportProgress,
        });
        return { __sfc: true, monitoringSource, props, emit, hasExistingStsExportData, hasExistingRemoteExportData, exportToStsRequest, exportToRemoteRequest, updateExistingExportProgress, dismissStsExport, dismissRemoteExport, BCard, PersistentTaskProgressMonitorAlert };
    }
});
